
export const Credentials = {
    url: "https://gdn1.prod.macrometa.io",
    email:"demo@macrometa.io",
    password: "demo",
    fabric: "_system"

}
